import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { AuthService } from "@app/services/auth.service";

@NgFilter({
    token: Token.HasRoleFilter,
    dependencies: [
        Token.AuthService
    ]
})
export class HasRoleFilter {
    constructor(
        private authService: AuthService
    ) {
        return ((role: string) => {
            return this.authService.hasRole(role);
        }) as any;
    }
}
